﻿import { room_passengers_type } from "./room_passengers_type";

export class room_passengers {
    public passengers: number | null = null;
    public room_types: room_passengers_type[] = [];
}
